import { Fragment, useEffect, useRef } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";

import { Avatar } from "@mui/material";

import clsx from "clsx";

import KTOffcanvas from "_metronic/_assets/js/offcanvas";
import * as builder from "_metronic/ducks/builder";
import Menu from "_metronic/layout/aside/Menu";
import Brand from "_metronic/layout/brand/Brand";

import WorkspaceSwitcher from "app/common/workspace/WorkspaceSwitcher";

const AsideLeft = (props) => {
  const asideOffCanvasRef = useRef();

  // Redux selectors using useSelector hook
  const user = useSelector((store) => store.auth && store.auth.user);
  const disableScroll = useSelector(
    (store) => builder.selectors.getConfig(store, "aside.menu.dropdown") === "true" || false
  );
  const asideClassesFromConfig = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "aside",
      toString: true,
    })
  );

  useEffect(() => {
    const menuCanvasOptions = {
      baseClass: "kt-aside",
      overlay: true,
      closeBy: "kt_aside_close_btn",
      toggleBy: {
        target: "kt_aside_mobile_toggler",
        state: "kt-header-mobile__toolbar-toggler--active",
      },
    };

    new KTOffcanvas(asideOffCanvasRef.current, menuCanvasOptions);
  }, []);

  return (
    <Fragment>
      <button className="kt-aside-close" id="kt_aside_close_btn">
        <i className="la la-close" />
      </button>
      <div
        id="kt_aside"
        ref={asideOffCanvasRef}
        className={`kt-aside ${asideClassesFromConfig} kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop`}
      >
        <Brand />

        {user && (
          <div className="aside-user-profile px-30 d-flex align-items">
            <div className="d-flex align-items-center">
              <div className="mr-1">
                <Avatar className="user-avatar">
                  {`${user.firstName[0]}${user.lastName[0]}`.toUpperCase()}
                </Avatar>
              </div>
              <div>
                <div className="username ml-2 text-primary-dark">
                  {user.firstName + " " + user.lastName}
                </div>
                <div className="username ml-2">{user.company}</div>
              </div>
            </div>
          </div>
        )}

        <div
          id="kt_aside_menu_wrapper"
          className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
        >
          {disableScroll && <Menu htmlClassService={props.htmlClassService} />}
          {!disableScroll && (
            <PerfectScrollbar options={{ wheelSpeed: 2, wheelPropagation: false }}>
              <Menu htmlClassService={props.htmlClassService} />
            </PerfectScrollbar>
          )}
        </div>

        <div className="workspace-switcher-aside">
          <WorkspaceSwitcher />
        </div>

        <div
          className={clsx("text-center py-4", {
            "d-none": import.meta.env.VITE_ENV === "production",
          })}
        >
          {`v ${import.meta.env.VITE_VERSION_CODE}`}
        </div>
      </div>
    </Fragment>
  );
};

export default AsideLeft;
